<div class="flex-1 flex-col align-end-stretch">
    <div class="state">
        {{'RDP_HTML5.' + state | translate}}...
    </div>
    <mat-progress-bar mode="determinate" color="accent" [value]="stateCount"></mat-progress-bar>
</div>
